import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input, OnChanges, PLATFORM_ID, Inject, computed } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import MetisMenu from 'metismenujs';
import { Router, NavigationEnd, RouterModule } from '@angular/router';

import { HttpClient } from '@angular/common/http';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SimplebarAngularModule } from 'simplebar-angular';
import { CommonModule } from '@angular/common';
import { MENU } from '../../core/helpers/menu';
import { MenuItem } from "../../models/menu/menu.model";
// Import the Utility class
import { Utility } from '../../core/helpers/utility';
import { CurrentUserService } from '../../core/auth/current-user.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: [],
  standalone:true,
  imports:[SimplebarAngularModule,RouterModule,CommonModule,TranslateModule ]
})

/**
 * Sidebar component
 */
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('componentRef') scrollRef;
  @Input() isCondensed = false;
  menu: any;
  data: any;

  menuItems: MenuItem[] = [];

  // Reactive user role from CurrentUserService signal
  userRole = computed(() => this.currentUserService.userRole() ?? '');

  @ViewChild('sideMenu') sideMenu: ElementRef;
  // Create an instance of the Utility class
  private utility: Utility;
  private isBrowser: boolean;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private http: HttpClient,
    private currentUserService: CurrentUserService,
    @Inject(PLATFORM_ID) platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.utility = new Utility();

    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
        this._scrollElement();
      }
    });
  }

  ngOnInit() {
    this.initialize();
    if (this.isBrowser) {
      this._scrollElement();
    }
  }

  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);
    this._activateMenuDropdown();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  ngOnChanges() {
    if (!this.isCondensed && this.sideMenu || this.isCondensed) {
      setTimeout(() => {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }
  _scrollElement() {
    setTimeout(() => {
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition = document.getElementsByClassName("mm-active")[0]['offsetTop'];
        if (currentPosition > 500)
          if (this.scrollRef.SimpleBar !== null)
            this.scrollRef.SimpleBar.getScrollElement().scrollTop =
              currentPosition + 300;
      }
    }, 300);
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-show');
    const links = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;

    const currentPathname = window.location.pathname;
    const currentSearch = window.location.search;

    // First, try to find an exact match including query params
    if (currentSearch) {
      for (let i = 0; i < links.length; i++) {
        const linkEl = links[i] as HTMLAnchorElement;
        if (linkEl.pathname === currentPathname && linkEl.search === currentSearch) {
          menuItemEl = linkEl;
          break;
        }
      }
    }

    // Fallback: match by pathname only (original behaviour)
    if (!menuItemEl) {
      const paths = [];
      for (let i = 0; i < links.length; i++) {
        paths.push(links[i]['pathname']);
      }
      var itemIndex = paths.indexOf(currentPathname);
      if (itemIndex === -1) {
        const strIndex = currentPathname.lastIndexOf('/');
        const item = currentPathname.substr(0, strIndex).toString();
        menuItemEl = links[paths.indexOf(item)];
      } else {
        menuItemEl = links[itemIndex];
      }
    }

    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add('mm-active');
        const parent2El = parentEl.parentElement.closest('ul');
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.add('mm-show');
          const parent3El = parent2El.parentElement;
          if (parent3El && parent3El.id !== 'side-menu') {
            parent3El.classList.add('mm-active');
            const childAnchor = parent3El.querySelector('.has-arrow');
            const childDropdown = parent3El.querySelector('.has-dropdown');
            if (childAnchor) { childAnchor.classList.add('mm-active'); }
            if (childDropdown) { childDropdown.classList.add('mm-active'); }
            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== 'side-menu') {
              parent4El.classList.add('mm-show');
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== 'side-menu') {
                parent5El.classList.add('mm-active');
                const childanchor = parent5El.querySelector('.is-parent');
                if (childanchor && parent5El.id !== 'side-menu') { childanchor.classList.add('mm-active'); }
              }
            }
          }
        }
      }
    }

  }

  /**
   * Initialize
   */
  initialize(): void {
    this.menuItems = MENU;
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * Using the Utility method to check user access
   */
  checkRoleAccess(roleList?: string[]) {
    return this.utility.showFromRole(roleList?.length ? roleList : [], this.userRole());
  }
}
